import React, { useState } from 'react'
import map_pin from '../assets/images/map_pin.svg';
export default function SecondaryNavbar(data) {
    const [navbar_tabs, setCountNavbar_tabs] = useState(['Dashboard', 'Dispatched', 'Zone Master', 'Area Master']);
    const [plant_options, setplant_options] = useState(['India', 'Pune', 'Mumbai', 'Kanpur', 'Lucknow']);

    function setMyValue(value) {
        console.log("dropdown value = ", value)
    }

    return (
        <>
        <div className='secondary-navbar-container'>
            <ul className='secondary-navbar'>
                {
                    navbar_tabs.map((tabs, index) => {
                        return (
                            <li className='secondary-navbar-tabs' key={index}> {tabs} </li>
                        )
                    })
                }
            </ul>
            <div className="dashboard-main-dropdown">
                <img src={map_pin} alt="map-marker" style={{ height: "100%", margin: "0 0.5rem" }} />
                <select className='dropdown-main' onChange={(e) => setMyValue(e.target.value)} defaultValue={"India"}                                >
                    {
                        plant_options.map((option, idx) => (
                            <option key={idx}>{option}</option>
                        ))
                    }
                </select>
            </div>
            </div>
        </>
    )
}